import axios from 'axios';

const cache = new Map();
const DEFAULT_TTL = 60000; // 60 seconds

/**
 * Cached GET request — returns cached data if fresh, otherwise fetches.
 * @param {string} url - Full API URL
 * @param {number} ttl - Cache lifetime in ms (default 60s)
 * @returns {Promise} response data
 */
export async function cachedGet(url, ttl = DEFAULT_TTL) {
  const now = Date.now();
  const entry = cache.get(url);
  if (entry && now - entry.ts < ttl) {
    return entry.data;
  }
  const res = await axios.get(url);
  cache.set(url, { data: res, ts: now });
  return res;
}

/**
 * Invalidate cache entries matching a prefix
 */
export function invalidateCache(prefix) {
  for (const key of cache.keys()) {
    if (key.includes(prefix)) {
      cache.delete(key);
    }
  }
}

/**
 * Clear all cache
 */
export function clearCache() {
  cache.clear();
}
